module.exports = __webpack_public_path__ + "img/host-it.jpg_w545.ce441b09.jpg";